import { dateFormatter } from '../services/calculations/calendarFormatters';
const HOUR_MS = 60 * 60 * 1000;

export const zonedParts = (instant, timezone) => Object.fromEntries(
  dateFormatter('en-US', {
    timeZone: timezone, year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23',
  }).formatToParts(new Date(instant)).filter((part) => part.type !== 'literal')
    .map((part) => [part.type, Number(part.value)])
);

// Resolve a local calendar boundary without depending on the browser's zone.
export const zonedInstant = (parts, timezone) => {
  const localUtc = Date.UTC(parts.year, parts.month - 1, parts.day,
    parts.hour || 0, parts.minute || 0, parts.second || 0);
  let result = localUtc;
  for (let index = 0; index < 4; index += 1) {
    const actual = zonedParts(result, timezone);
    const actualUtc = Date.UTC(actual.year, actual.month - 1, actual.day,
      actual.hour, actual.minute, actual.second);
    const adjustment = localUtc - actualUtc;
    result += adjustment;
    if (!adjustment) break;
  }
  return result;
};

export const energyWindow = (range, now = Date.now(), timezone = 'America/New_York') => {
  const end = Math.floor(now / 10000) * 10000;
  let start;
  if (range === 'month') {
    const local = zonedParts(end, timezone);
    const previousMonth = new Date(Date.UTC(local.year, local.month - 2, 1));
    const year = previousMonth.getUTCFullYear();
    const month = previousMonth.getUTCMonth() + 1;
    const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
    start = zonedInstant({ ...local, year, month, day: Math.min(local.day, lastDay) }, timezone);
  } else {
    start = end - ({ hour: 1, day: 24, week: 168 }[range] || 24) * HOUR_MS;
  }
  const local = zonedParts(end, timezone);
  const todayStart = zonedInstant({ year: local.year, month: local.month, day: local.day }, timezone);
  return {
    start: new Date(start).toISOString(), end: new Date(end).toISOString(), timezone,
    bucketSeconds: { hour: 10, day: 300, week: 1800, month: 7200 }[range] || 300,
    todayStart: new Date(todayStart).toISOString(),
  };
};
